import React from "react";

import { type IntegrationProvider, integrations } from ".";

import type { BillingFeatureAccessType } from "~/billing/utils";
import { Modal } from "~/ui/legacyFellowIndex";
import { __globalModalContext } from "~/ui/modals";

import type { JiraIntegrationLinkProps } from "../jira";
import { ActionItemIntegrationKebabModalCard } from "./actionItemIntegrationKebabModalCard";
import type { ActionItemLinkingModalProps } from "./actionItemLinkingModal";

import styles from "./css/kebabModal.module.css";

export interface AllActionItemIntegrationsModalProps {
	activeIntegrations: Set<IntegrationProvider>;
	actionItemLinkingModalProps: Omit<ActionItemLinkingModalProps, "integration">;
	billingFeatureAccess: BillingFeatureAccessType | undefined;
	jiraProps: JiraIntegrationLinkProps;
}

function AllActionItemIntegrationsModal({
	activeIntegrations,
	actionItemLinkingModalProps,
	billingFeatureAccess,
	jiraProps,
	close,
}: AllActionItemIntegrationsModalProps & { close: () => void }) {
	const alphabeticalIntegrations = Array.from(integrations).sort((a, b) => a.displayName.localeCompare(b.displayName));

	return (
		<Modal onClose={close}>
			<Modal.Header onClose={close}>
				<Modal.Title>Connect integration</Modal.Title>
			</Modal.Header>
			<Modal.Body className={styles.modalBody}>
				<p>
					Automatically send action items to your task management system of choice. Choose an integration to get
					started:
				</p>
				<div className={styles.cardsContainer}>
					{alphabeticalIntegrations.map(integration => (
						<ActionItemIntegrationKebabModalCard
							key={integration.key}
							integration={integration}
							actionItemLinkingModalProps={actionItemLinkingModalProps}
							billingFeatureAccess={billingFeatureAccess}
							activeIntegrations={activeIntegrations}
							jiraProps={jiraProps}
							closeParentModal={close}
						/>
					))}
				</div>
			</Modal.Body>
		</Modal>
	);
}

export function displayAllActionItemIntegrationsModal(
	props: Omit<AllActionItemIntegrationsModalProps, "closeParentModal">,
) {
	__globalModalContext?.open(({ close }) => <AllActionItemIntegrationsModal {...props} close={close} />);
}
